import $i18n from 'panda-i18n';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { CnSelect } from '@/components/cn-select';
import { formatResponse, processDataSource, search } from './service';
import CnEmployeeItem from './employee-item';
import { useUpdateEffect } from 'ahooks';
import { isFunction } from 'lodash';
const CnEmployeeSelect = (props) => {
    const { mokelay = true, host, path, serviceType, dataSource: propDataSource, typeList, isOnJob, isPreview, readOnly, prefix = 'cn-ui-m-', service, onChange, ...others } = props;
    const [dataSource, setDataSource] = useState([]);
    const timer = React.useRef();
    const serviceRef = React.useRef(service);
    const clsPrefix = `${prefix}employee-select`;
    useUpdateEffect(() => {
        serviceRef.current = service;
    }, [service]);
    // value变化时查询具体员工信息
    useEffect(() => {
        const fetchInitData = async () => {
            let realValue = props.value;
            if (Object.prototype.toString.call(props.value) === '[object Object]') {
                realValue = props.value.value || props.value.workNo;
            }
            const result = await search({
                value: realValue,
                mokelay,
                host,
                path,
                serviceType,
                typeList,
                isOnJob,
                fromType: 'staffId',
            });
            setDataSource(result);
        };
        if (!props.value || !serviceType || propDataSource)
            return;
        fetchInitData();
    }, [
        props.value,
        host,
        mokelay,
        path,
        serviceType,
        typeList,
        isOnJob,
        propDataSource,
    ]);
    // 搜索逻辑
    const handleSearch = useCallback(async (val) => {
        if (serviceRef.current) {
            const temp = await serviceRef.current(val, 'keywords');
            const result = formatResponse(temp);
            setDataSource(result);
            return;
        }
        if (!serviceType || propDataSource) {
            return;
        }
        if (!val) {
            setDataSource([]);
            return;
        }
        clearTimeout(timer.current);
        timer.current = setTimeout(async () => {
            const result = await search({
                value: val,
                mokelay,
                host,
                path,
                serviceType,
                typeList,
                isOnJob,
                fromType: 'keywords',
            });
            setDataSource(result);
        }, 300);
    }, [host, mokelay, serviceType, path, typeList, isOnJob, propDataSource]);
    // 当传入外部数据源时，自动格式化并赋值到组件
    useEffect(() => {
        if (!Array.isArray(propDataSource))
            return;
        setDataSource(processDataSource(propDataSource));
    }, [propDataSource]);
    return (React.createElement(CnSelect, { notFoundContent: $i18n.get({
            id: 'NoRelevantPersonnelDataHaveNot_1705518629',
            dm: '暂无未找到相关人员数据',
            ns: 'CnEmployeeSelect',
        }), placeholder: $i18n.get({
            id: 'PleaseEnterWorkNumberOrFlower_129025031',
            dm: '请输入工号或花名',
            ns: 'CnEmployeeSelect',
        }), onSearch: handleSearch, renderSelection: (opts) => {
            if (!opts.length)
                return null;
            return opts
                .map((i) => i.label || i.nickName || i.name || i.value)
                .join('，');
        }, renderPreview: (values) => (React.createElement("div", { className: `${clsPrefix}-readonly` }, processDataSource(values).map((item) => (React.createElement(CnEmployeeItem, { data: item, mini: true }))))), isPreview: readOnly || isPreview, filterLocal: false, showSearch: true, dataSource: dataSource, renderItem: (item) => React.createElement(CnEmployeeItem, { data: item }), onChange: (value, actionType, items) => {
            if (!isFunction(onChange))
                return;
            if (props.useDetailValue) {
                const valueItem = dataSource.find((i) => i.value === value.value) || value;
                onChange(valueItem, actionType, items);
            }
            else {
                onChange(value, actionType, items);
            }
        }, ...others }));
};
CnEmployeeSelect.displayName = 'CnEmployeeSelect';
CnEmployeeSelect.defaultProps = {
    mokelay: true,
    typeList: ['REGULAR', 'OUTSOURCING'],
    isOnJob: true,
};
export { CnEmployeeSelect };
